import { useEffect, useState } from 'react';
import type { DefaultTheme } from 'styled-components';
import { Card } from '../Card';
import { Text } from '../Text';

interface StateLastUpdatedProps {
  state: any;
  size?: keyof DefaultTheme;
}

export const StateLastUpdated = ({ state, size = 'fontSizeSm' }: StateLastUpdatedProps) => {
  const [lastUpdatedTS, setLastUpdatedTS] = useState<string>(new Date().toISOString());

  useEffect(() => {
    setLastUpdatedTS(new Date().toISOString());
  }, [state]);

  return (
    <Card p="spacing4">
      <Text fontSize={size}>
        <code>State last updated at {lastUpdatedTS}</code>
      </Text>
    </Card>
  );
};
